export default __webpack_public_path__ + "static/media/rss-feed.b369c562.svg";